import type {HttpClient} from '@sollapay/http-client';
import type {ApiResponse, PurchaseSummaryDTO} from '@sollapay/types';

export const purchasesApi = {
  fetchPurchaseSummary: async (
    client: HttpClient,
    trustAccountId: string
  ): Promise<ApiResponse<PurchaseSummaryDTO | null>> => {
    return client.get<ApiResponse<PurchaseSummaryDTO | null>>(
      `/trust_accounts/${trustAccountId}/purchases/summary`
    );
  }
};
